import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { filter } from 'lodash';

import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';
import { PlanterService } from '@asambleas-services/planter/planter.service';
import { EditSeederGroupDataComponent } from '@asambleas-components/modals/edit-seeder-group-data/edit-seeder-group-data.component';
import { EditSeederGroupMetricsComponent } from '@asambleas-components/modals/edit-seeder-group-metrics/edit-seeder-group-metrics.component';

@Component({
  selector: 'app-seeder-dash',
  templateUrl: './seeder-dash.component.html',
  styleUrls: ['./seeder-dash.component.scss']
})
export class SeederDashComponent implements OnInit {

    planterGroups = {
        seeder_id: '',
        groups: []
    };
    // Defines if all the needed resources has load
    resourcesHasLoaded: boolean = false;
    // Defines if there ir an operation in progress
    operationInProgress: boolean = false;

    constructor(
        private planterService: PlanterService,
        private userFeedback: UserFeedbackService,
        private dialog: MatDialog) {}

    ngOnInit() {

        this.planterService.getPlanterGroups()
            .then(planterGroups => {

                this.planterGroups = planterGroups;

            })
            .catch(error => {

                this.userFeedback.openDialog({ body: error });

            })
            .then(() => this.resourcesHasLoaded = true);

    }

    openEditGroupDataModal(planterGroup): void {

        const dialogOptions: any = {
            disableClose: true,
            data: planterGroup
        };

        if (window.screen.width >= 700) {

            dialogOptions.maxWidth = '400px';

        }

        let dialogRef = this.dialog.open(EditSeederGroupDataComponent, dialogOptions);

        dialogRef.afterClosed()
            .subscribe(planterGroupData => {

                if (planterGroupData) {

                    this.operationInProgress = true;

                    this.planterService.updatePlanterGroup(planterGroupData)
                        .then(planterGroupDataResponse => {

                            planterGroup.name = planterGroupDataResponse.name;
                            planterGroup.address = planterGroupDataResponse.address;
                            planterGroup.description = planterGroupDataResponse.description;
                            planterGroup.updated_at = planterGroupDataResponse.updated_at;

                            this.userFeedback.openSnackbar({ message: 'Operación exitosa' });

                        })
                        .catch(error => {

                            this.userFeedback.openDialog({ body: error });

                        })
                        .then(() => this.operationInProgress = false);

                }

            });

    }

    openEditGroupMetricsModal(planterGroup): void {

        const dialogOptions: any = {
            disableClose: true,
            data: planterGroup
        };

        if (window.screen.width >= 700) {

            dialogOptions.maxWidth = '420px';

        }

        let dialogRef = this.dialog.open(EditSeederGroupMetricsComponent, dialogOptions);

        dialogRef.afterClosed()
            .subscribe(planterGroupData => {

                if (planterGroupData) {

                    this.operationInProgress = true;

                    this.planterService.updatePlanterGroup(planterGroupData)
                        .then(planterGroupDataResponse => {

                            planterGroup.conversions = planterGroupDataResponse.conversions;
                            planterGroup.discipled = planterGroupDataResponse.discipled;
                            planterGroup.baptism = planterGroupDataResponse.baptism;
                            planterGroup.leaders = planterGroupDataResponse.leaders;
                            planterGroup.small_groups = planterGroupDataResponse.small_groups;
                            planterGroup.weekly_attendees = planterGroupDataResponse.weekly_attendees;
                            planterGroup.updated_at = planterGroupDataResponse.updated_at;

                            this.userFeedback.openSnackbar({ message: 'Operación exitosa' });

                        })
                        .catch(error => {

                            this.userFeedback.openDialog({ body: error });

                        })
                        .then(() => this.operationInProgress = false);

                }

            });

    }

    addPlanterGroup(): void {

        const dialogOptions: any = {
            disableClose: true,
            data: {}
        };

        if (window.screen.width >= 700) {

            dialogOptions.maxWidth = '400px';

        }

        let dialogRef = this.dialog.open(EditSeederGroupDataComponent, dialogOptions);

        dialogRef.afterClosed()
            .subscribe(planterGroupData => {

                if (planterGroupData) {

                    this.operationInProgress = true;

                    planterGroupData.seeder_id = this.planterGroups.seeder_id;

                    this.planterService.createPlanterGroup(planterGroupData)
                        .then(planterGroupDataResponse => {

                            this.planterGroups.groups.push(planterGroupDataResponse);

                            this.userFeedback.openSnackbar({ message: 'Operación exitosa' });

                        })
                        .catch(error => {

                            this.userFeedback.openDialog({ body: error });

                        })
                        .then(() => this.operationInProgress = false);

                }

            });

    }

    deletePlanterGroup(planterGroup): void {

        this.userFeedback.openDialog({
            type: 'confirm',
            body: 'Esta seguro que desea eliminar el grupo?'
        })
        .afterClosed()
        .subscribe((proceed: boolean) => {

            if (proceed) {

                this.operationInProgress = true;

                this.planterService.deletePlanterGroup(planterGroup)
                    .then(() => {

                        this.planterGroups.groups = filter(this.planterGroups.groups, group => group.id !== planterGroup.id);

                        this.userFeedback.openSnackbar({ message: 'Operación exitosa' });

                    })
                    .catch(error => {

                        this.userFeedback.openDialog({ body: error });

                    })
                    .then(() => this.operationInProgress = false);

            }

        });

    }

    getDateMillis(date: string): number | string {

        if (!date) return '';

        return (new Date(date)).getTime();

    }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/extension/seeder-dash/seeder-dash.component.ts